import sample_01 from './bodyforce.jpg';

export const bodyworksImpressions = {
    sample_01,
};
